import InsightsDataFetchSource from '../store/schema/InsightsDataFetchSource';
import SubstrateSearchScenario from 'owa-search-service/lib/data/schema/SubstrateSearchScenario';
import { OUTLOOK_DESKTOP, O365_SHELL, getOpxHostApp } from 'owa-config';

export default function getScenarioEndpoint(
    dataFetchSource: InsightsDataFetchSource
): SubstrateSearchScenario {
    const hostApp = getOpxHostApp();

    // Special endpoints for OPX scenarios. If these hosts ever have multiple
    // UI endpoints we'll need to update both here and on the server to reflect
    // ReadingPane/Peek/etc in the name
    if (hostApp == OUTLOOK_DESKTOP) {
        return SubstrateSearchScenario.MeetingPrepDesktop;
    } else if (hostApp == O365_SHELL) {
        return SubstrateSearchScenario.MeetingPrepShell;
    }

    switch (dataFetchSource) {
        // Meeting Insights endpoint
        case InsightsDataFetchSource.ReadingPane:
        case InsightsDataFetchSource.Deeplink:
        case InsightsDataFetchSource.TabbedDetailsForm:
            return SubstrateSearchScenario.MeetingPrep;

        case InsightsDataFetchSource.ItemPeek:
            return SubstrateSearchScenario.MeetingPrepPeek;

        case InsightsDataFetchSource.Reminder:
            return SubstrateSearchScenario.MeetingPrepReminder;
        case InsightsDataFetchSource.CalendarCard:
            return SubstrateSearchScenario.MeetingPrepMailCalendarCard;

        case InsightsDataFetchSource.PrefetchOnCalendarSelected:
        case InsightsDataFetchSource.PrefetchOnAgendaView:
            return SubstrateSearchScenario.MeetingPrepPrefetch;

        // Up-next agenda view endpoint
        case InsightsDataFetchSource.AgendaView:
        case InsightsDataFetchSource.TimePanelEventDetails:
        case InsightsDataFetchSource.UpNext:
        default:
            return SubstrateSearchScenario.MeetingPrepAgenda;
    }
}
